import React from 'react'
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import ReportFilter from './containers/ReportResFilter'
import ReportList from './containers/ReportResList'

const mapStateToProps = state => {  
  return {    
    isLogged: state.user.isLogged,        
  }
}

class Report extends React.Component{
  
  render() {
    if (!this.props.isLogged)
      return <Redirect to='/'/>;
      
    return this.renderReport()
  }
  renderReport(){
    return (
      <div>        
        <ReportFilter/>
        <ReportList />
      </div>
    )
  }
}
export default connect(
  mapStateToProps,
  //mapDispatchToProps
)(Report)


// WEBPACK FOOTER //
// ./src/ReportRes.js